import { Alert } from "antd";

const Payers = () => {
	return <Alert
				className="mb-6"
				type="info"
				showIcon
				message="Feature coming soon"
				description="This section is currently under development."
			/>
};

export default Payers;
